// React
import React from 'react';
// Internal
import NavbarPrimary from 'components/shared/organisms/NavbarPrimary/NavbarPrimary';
import NavbarSecondary from 'components/shared/organisms/NavbarSecondary/NavbarSecondary';
import PageTitle from 'components/shared/atoms/PageTitle/PageTitle';
import ContentCard from 'components/shared/organisms/ContentCard/ContentCard';
// Styles
import './styles.scss';

class UpdatePassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            /**
             *  @todo remove the vetId hardcoded and make it dynamic based on the auth credentials
             */
            vetId: '91a39742-9029-11ea-817d-080027ecb0c1'
        };

        this.getTeamMemberList();
    }

    render() {
        return (
            <div className="main-container">
                <NavbarSecondary />
                <NavbarPrimary />
                <div className="body-content">
                    <PageTitle title="Password" />
                    <ContentCard
                        className="mt-62"
                        headerTitle="Update password"
                        headerSubComponent={(
                            <p className="pw-sub-header">
                                To update your password, enter your current password and then your desired new password.
                                Click
                                <span className="bold">update password</span>
                                when complete.
                            </p>
                        )}
                    >
                        <div>text</div>
                    </ContentCard>
                </div>
            </div>
        );
    }
}

export default UpdatePassword;
